import { render, staticRenderFns } from "./AddPlanBenefit.vue?vue&type=template&id=7c9a3618&"
import script from "./AddPlanBenefit.vue?vue&type=script&lang=js&"
export * from "./AddPlanBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports